//数据校验

export const mobile_pattern = /^1[3-9]\d{9}$/
//身份证号码校验
//身份证号(15位、18位数字)，最后一位是校验位，可能为数字或字符X：(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)
export function verifyIDCard(input) {
  let pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  let out = pattern.test(input);
  return out;
}
//手机号校验
//手机号码：
export function verifyMobile(input) {
  let pattern = mobile_pattern
  return pattern.test(input);
}

// //固定电话校验
// //电话号码("XXX-XXXXXXX"、"XXXX-XXXXXXXX"、"XXX-XXXXXXX"、"XXX-XXXXXXXX"、"XXXXXXX"和"XXXXXXXX)：^((\d{3,4}-)|\d{3.4}-)?\d{7,8}$
export function verifyPhone(input) {
  let pattern = /^((\d{3,4}-)|\d{3.4}-)?\d{7,8}$/;
  return pattern.test(input);
}

export function generateRandomNumericString(length) {
    const digits = '0123456789';
    let result = '';
    const digitsLength = digits.length;
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * digitsLength);
        result += digits[randomIndex];
    }
    return result;
}



// WEBPACK FOOTER //
// ./src/js/verifyData.js